<template>
  <div class="bg-gray-50" @click="closeAllDropdowns">
    <div class="template-editor-container flex bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden">
    <!-- 左侧模板库面板 -->
    <div class="w-80 bg-white border-r border-gray-200 flex flex-col">
      <!-- 我的模板标题 + 新建按钮 + 搜索框 -->
      <div class="px-4 h-12 border-b border-gray-200 bg-gray-50 flex items-center justify-between gap-2">
        <h3 class="text-xs font-semibold text-gray-500 uppercase tracking-wider flex-shrink-0">我的模板</h3>
        <div class="flex items-center gap-2">
          <button 
            @click="createNewTemplate"
            class="flex items-center px-2 py-1 bg-white text-gray-700 text-xs font-medium rounded border border-gray-300 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-blue-500 transition-colors flex-shrink-0"
          >
            <PlusIcon class="w-3 h-3 mr-1" />
            新建
          </button>
            <button 
              @click="manageCategoriesModal = true"
            class="flex items-center px-2 py-1 bg-white text-gray-700 text-xs font-medium rounded border border-gray-300 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-blue-500 transition-colors flex-shrink-0"
            >
            <svg class="w-3 h-3 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012 2v2M7 7h10" />
            </svg>
            分类
          </button>
        <div class="relative">
          <input
            v-model="searchQuery"
            type="text"
              placeholder="搜索..."
              class="w-24 pl-6 pr-2 py-1 border border-gray-300 rounded text-xs focus:ring-1 focus:ring-blue-500 focus:border-transparent"
          />
            <div class="absolute inset-y-0 left-0 pl-1.5 flex items-center pointer-events-none">
              <MagnifyingGlassIcon class="h-3 w-3 text-gray-400" />
          </div>
        </div>
        </div>
      </div>
      
      <!-- 分类筛选 -->
      <div class="px-4 py-2 border-b border-gray-200 bg-white">
        <div class="relative" ref="categorySelectRef" @click.stop>
          <!-- 触发器 -->
          <div
            @click.stop="toggleCategoryDropdown"
            class="relative w-full h-8 cursor-pointer bg-white border border-gray-300 rounded-lg px-2 text-left shadow-sm hover:border-blue-500 hover:ring-1 hover:ring-blue-500 transition-colors flex items-center"
            :class="{ 'border-blue-500 ring-1 ring-blue-500': isCategoryOpen }"
          >
            <span class="flex-1 truncate text-xs text-gray-900">
              {{ selectedCategory ? categories.find(c => c.id == selectedCategory)?.name : '全部分类' }}
              <span v-if="selectedCategory" class="text-gray-500 ml-1">({{ categories.find(c => c.id == selectedCategory)?.template_count }})</span>
            </span>
            <span class="pointer-events-none flex items-center pl-2">
              <svg 
                class="h-4 w-4 text-gray-400 transition-transform duration-200"
                :class="{ 'rotate-180': isCategoryOpen }"
                xmlns="http://www.w3.org/2000/svg" 
                viewBox="0 0 20 20" 
                fill="currentColor"
              >
                <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd" />
              </svg>
            </span>
      </div>
      
          <!-- 下拉列表 -->
          <transition
            enter-active-class="transition duration-100 ease-out"
            enter-from-class="transform scale-95 opacity-0"
            enter-to-class="transform scale-100 opacity-100"
            leave-active-class="transition duration-75 ease-in"
            leave-from-class="transform scale-100 opacity-100"
            leave-to-class="transform scale-95 opacity-0"
          >
            <div
              v-show="isCategoryOpen"
              class="absolute z-50 mt-1 w-full bg-white shadow-lg max-h-60 rounded-lg py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none"
            >
              <!-- 全部分类选项 -->
              <div
                @click.stop="selectCategory('')"
                class="group relative cursor-pointer select-none py-2 pl-3 pr-9 text-gray-900 hover:bg-blue-50 hover:text-blue-900 transition-colors"
                :class="{ 'bg-blue-100 text-blue-900': !selectedCategory }"
              >
                <span class="block truncate text-xs font-medium">
                  全部分类
                </span>
                <span 
                  v-if="!selectedCategory"
                  class="absolute inset-y-0 right-0 flex items-center pr-3 text-blue-600"
                >
                  <svg class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                  </svg>
                </span>
              </div>
              
              <!-- 分类选项 -->
              <div
                v-for="category in categories"
                :key="category.id"
                @click.stop="selectCategory(category.id)"
                class="group relative cursor-pointer select-none py-2 pl-3 pr-9 text-gray-900 hover:bg-blue-50 hover:text-blue-900 transition-colors"
                :class="{ 'bg-blue-100 text-blue-900': selectedCategory == category.id }"
              >
                <span class="block truncate text-xs font-medium">
                  {{ category.name }} <span class="text-gray-500">({{ category.template_count }})</span>
                </span>
                <span 
                  v-if="selectedCategory == category.id"
                  class="absolute inset-y-0 right-0 flex items-center pr-3 text-blue-600"
                >
                  <svg class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                  </svg>
                </span>
              </div>
            </div>
          </transition>
        </div>
      </div>
      
      <!-- 模板列表 -->
      <div class="flex-1 overflow-y-auto">
        <div v-if="loading" class="p-4">
          <div class="animate-pulse space-y-2">
            <div class="h-4 bg-gray-200 rounded"></div>
            <div class="h-4 bg-gray-200 rounded w-4/5"></div>
            <div class="h-4 bg-gray-200 rounded w-3/5"></div>
          </div>
        </div>
        
        <div v-else-if="templates.length === 0" class="p-8 text-center text-gray-500">
          <DocumentTextIcon class="mx-auto h-12 w-12 text-gray-400 mb-4" />
          <p class="text-sm">{{ searchQuery ? '没有找到匹配的模板' : '暂无邮件模板' }}</p>
          <p class="text-xs text-gray-400 mt-1">
            {{ searchQuery ? '尝试调整搜索条件' : '创建您的第一个邮件模板' }}
          </p>
        </div>
        
        <div v-else class="divide-y divide-gray-100">
          <div
            v-for="template in templates"
            :key="template.id"
            class="p-4 hover:bg-gray-50 cursor-pointer transition-colors relative"
            :class="{ 
              'bg-blue-50': currentTemplate?.id === template.id,
              'opacity-50 pointer-events-none': loadingTemplateId && loadingTemplateId !== template.id
            }"
            @click="selectTemplate(template)"
          >
            <!-- 加载状态覆盖层 -->
            <div v-if="loadingTemplateId === template.id" class="absolute inset-0 bg-blue-50 bg-opacity-75 flex items-center justify-center">
              <div class="animate-spin h-5 w-5 text-blue-600">
                <svg class="w-5 h-5" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" fill="none"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
              </div>
            </div>
            <div class="flex items-start justify-between">
              <div class="flex-1 min-w-0">
                <h4 class="text-sm font-medium text-gray-900 truncate">{{ template.name }}</h4>
                <p class="text-xs text-gray-500 mt-1">{{ template.category_name || '未分类' }}</p>
                <p class="text-xs text-gray-400 mt-1 line-clamp-2">{{ template.preview_text || '暂无内容' }}</p>
                <div class="flex items-center mt-2 text-xs text-gray-400">
                  <span>使用 {{ template.usage_count || 0 }} 次</span>
                  <span class="mx-2">•</span>
                  <span>{{ formatDate(template.updated_at) }}</span>
                </div>
              </div>
              <div class="ml-2 flex-shrink-0">
                <div class="flex space-x-1">
                  <button
                    @click.stop="duplicateTemplate(template)"
                    class="p-1 text-gray-400 hover:text-gray-600"
                    title="复制模板"
                  >
                    <DocumentDuplicateIcon class="h-4 w-4" />
                  </button>
                  <button
                    @click.stop="deleteTemplate(template)"
                    class="p-1 text-gray-400 hover:text-red-600"
                    title="删除模板"
                  >
                    <TrashIcon class="h-4 w-4" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 中间编辑器面板 -->
    <div class="flex-1 flex flex-col bg-white">
      <!-- 顶部工具栏 -->
      <div class="px-4 h-12 border-b border-gray-200 bg-gray-50 flex items-center justify-between">
        <div class="flex items-center gap-2">
          <h3 class="text-xs font-semibold text-gray-500 uppercase tracking-wider">
              {{ isEditing ? '编辑模板' : '新建模板' }}
          </h3>
          <span v-if="currentTemplate" class="text-xs text-gray-500">{{ currentTemplate.name }}</span>
            <div v-if="isDirty" class="flex items-center text-xs text-orange-600">
            <div class="w-1.5 h-1.5 bg-orange-400 rounded-full mr-1"></div>
              未保存
            </div>
          </div>
        <div class="flex items-center gap-2">
          <button
            @click="showPreviewModal = true"
            class="flex items-center px-2 py-1 bg-white text-gray-700 text-xs font-medium rounded border border-gray-300 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-blue-500 transition-colors"
          >
            <EyeIcon class="w-3 h-3 mr-1" />
            预览
          </button>
            <button
              @click="saveTemplate(false)"
              :disabled="isSaving || !isDirty"
            class="flex items-center px-2 py-1 bg-white text-gray-700 text-xs font-medium rounded border border-gray-300 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            <CheckIcon v-if="!isSaving" class="w-3 h-3 mr-1" />
            <div v-else class="animate-spin w-3 h-3 mr-1">
              <svg class="w-3 h-3" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" fill="none"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
              </div>
            {{ isSaving ? '保存中' : '保存' }}
            </button>
        </div>
      </div>
      
      <!-- 编辑表单区域 -->
      <div class="flex-1 overflow-y-auto p-4">
        <div v-if="!currentTemplate && !showEditor" class="text-center py-8">
          <DocumentTextIcon class="mx-auto h-16 w-16 text-gray-300 mb-4" />
          <h3 class="text-lg font-medium text-gray-900 mb-2">选择一个模板开始编辑</h3>
          <p class="text-gray-500 mb-6">从左侧选择现有模板，或创建一个新模板</p>
          <button
            @click="createNewTemplate"
            class="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
        <PlusIcon class="h-4 w-4 mr-2" />
            创建新模板
      </button>
    </div>

        <div v-else class="flex flex-col h-full">
          <!-- 基本信息 -->
          <div class="flex-shrink-0 space-y-4 mb-4">
            <div class="grid grid-cols-2 gap-6">
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">模板名称 <span class="text-red-500">*</span></label>
                <input
                  v-model="formData.name"
                  type="text"
                  required
                  class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                  placeholder="输入模板名称"
                  @input="markDirty"
                />
              </div>
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">分类 <span class="text-red-500">*</span></label>
                <div class="relative" ref="formCategorySelectRef" @click.stop>
                  <!-- 触发器 -->
                  <div
                    @click.stop="toggleFormCategoryDropdown"
                    class="relative w-full h-10 cursor-pointer bg-white border border-gray-300 rounded-lg px-3 text-left shadow-sm hover:border-blue-500 hover:ring-1 hover:ring-blue-500 transition-colors flex items-center"
                    :class="{ 'border-blue-500 ring-1 ring-blue-500': isFormCategoryOpen }"
                  >
                    <span class="flex-1 truncate text-sm text-gray-900">
                      {{ formData.category ? categories.find(c => c.id == formData.category)?.name : '请选择分类' }}
                    </span>
                    <span class="pointer-events-none flex items-center pl-2">
                      <svg 
                        class="h-5 w-5 text-gray-400 transition-transform duration-200"
                        :class="{ 'rotate-180': isFormCategoryOpen }"
                        xmlns="http://www.w3.org/2000/svg" 
                        viewBox="0 0 20 20" 
                        fill="currentColor"
                      >
                        <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd" />
                      </svg>
                    </span>
                  </div>
                  
                  <!-- 下拉列表 -->
                  <transition
                    enter-active-class="transition duration-100 ease-out"
                    enter-from-class="transform scale-95 opacity-0"
                    enter-to-class="transform scale-100 opacity-100"
                    leave-active-class="transition duration-75 ease-in"
                    leave-from-class="transform scale-100 opacity-100"
                    leave-to-class="transform scale-95 opacity-0"
                  >
                    <div
                      v-show="isFormCategoryOpen"
                      class="absolute z-50 mt-1 w-full bg-white shadow-lg max-h-60 rounded-lg py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none"
                    >
                      <!-- 请选择分类选项 -->
                      <div
                        @click.stop="selectFormCategory('')"
                        class="group relative cursor-pointer select-none py-3 pl-3 pr-9 text-gray-900 hover:bg-blue-50 hover:text-blue-900 transition-colors"
                        :class="{ 'bg-blue-100 text-blue-900': !formData.category }"
                      >
                        <span class="block truncate text-sm font-medium">
                          请选择分类
                        </span>
                        <span 
                          v-if="!formData.category"
                          class="absolute inset-y-0 right-0 flex items-center pr-3 text-blue-600"
                        >
                          <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                          </svg>
                        </span>
                      </div>
                      
                      <!-- 分类选项 -->
                      <div
                        v-for="category in categories"
                        :key="category.id"
                        @click.stop="selectFormCategory(category.id)"
                        class="group relative cursor-pointer select-none py-3 pl-3 pr-9 text-gray-900 hover:bg-blue-50 hover:text-blue-900 transition-colors"
                        :class="{ 'bg-blue-100 text-blue-900': formData.category == category.id }"
                      >
                        <span class="block truncate text-sm font-medium">
                    {{ category.name }}
                        </span>
                        <span 
                          v-if="formData.category == category.id"
                          class="absolute inset-y-0 right-0 flex items-center pr-3 text-blue-600"
                        >
                          <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                          </svg>
                        </span>
                      </div>
                    </div>
                  </transition>
                </div>
              </div>
            </div>
            
            <!-- 邮件主题 -->
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-2">邮件主题 <span class="text-red-500">*</span></label>
              <input
                ref="subjectInput"
                v-model="formData.subject"
                type="text"
                required
                class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                placeholder="输入邮件主题，可使用变量如 {{customer_name}}"
                @input="markDirty"
                @focus="lastFocusedInput = 'subject'"
              />
            </div>
          </div>
          
          <!-- 邮件内容 -->
          <div class="flex-1 flex flex-col min-h-0">
            <label class="block text-sm font-medium text-gray-700 mb-2">邮件内容 <span class="text-red-500">*</span></label>
            <div class="flex-1">
              <TinyMCEEditor
                ref="editorInstance"
                v-model="formData.body_html"
                :height="calculateEditorHeight()"
                placeholder="输入邮件内容，可使用变量如 {{customer_name}}"
                @focus="lastFocusedInput = 'editor'"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 右侧预览和变量面板 -->
    <div class="w-preview bg-white border-l border-gray-200 flex flex-col">
      <!-- 实时预览 -->
      <div class="px-4 h-12 border-b border-gray-200 bg-gray-50 flex items-center">
        <h3 class="text-xs font-semibold text-gray-500 uppercase tracking-wider">实时预览</h3>
      </div>
      <div class="flex-shrink-0">
        <div class="bg-gray-50 rounded-lg h-80">
          <div v-if="!formData.subject && !formData.body_html" class="h-full flex items-center justify-center">
            <div class="text-center text-gray-400">
              <EyeSlashIcon class="h-8 w-8 mx-auto mb-2" />
              <p class="text-sm">填写内容后预览</p>
            </div>
          </div>
          <div v-else class="h-full flex flex-col p-4">
            <div class="mb-3 flex-shrink-0">
              <span class="text-xs text-gray-500">主题:</span>
              <div class="font-medium text-sm break-words">{{ formData.subject || '(无主题)' }}</div>
            </div>
            <div class="border-t pt-3 flex-1 overflow-hidden">
              <span class="text-xs text-gray-500">内容:</span>
              <div class="mt-1 text-sm h-full overflow-y-auto" v-html="formData.body_html || '(无内容)'"></div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- 可用变量 -->
      <div class="flex-1 flex flex-col min-h-0">
        <div class="px-4 h-12 border-t border-b border-gray-200 bg-gray-50 flex items-center">
          <h3 class="text-xs font-semibold text-gray-500 uppercase tracking-wider">可用变量</h3>
        </div>
        <div class="flex-1 overflow-y-auto p-4">
          <div class="space-y-1">
            <div
              v-for="variable in availableVariables"
              :key="variable.key"
              class="flex items-center justify-between p-2 hover:bg-gray-50 rounded-lg cursor-pointer border border-transparent hover:border-gray-200 transition-all"
              @click="insertVariable(variable)"
            >
              <div class="flex-1 min-w-0">
                <code class="text-xs text-blue-600 font-mono block">{{ variable.placeholder }}</code>
                <p class="text-xs text-gray-500 mt-1">{{ variable.description }}</p>
              </div>
              <PlusCircleIcon class="h-4 w-4 text-gray-400 hover:text-blue-500 transition-colors flex-shrink-0 ml-2" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 邮件模板市场面板 -->
    <div class="w-80 bg-white border-l border-gray-200 flex flex-col">
      <!-- 市场模板标题 + 搜索框 -->
      <div class="px-4 h-12 border-b border-gray-200 bg-gray-50 flex items-center justify-between gap-2">
        <h3 class="text-xs font-semibold text-gray-500 uppercase tracking-wider flex-shrink-0">邮件模板市场</h3>
        <div class="relative">
          <input
            v-model="marketSearchQuery"
            type="text"
            placeholder="搜索..."
            class="w-24 pl-6 pr-2 py-1 border border-gray-300 rounded text-xs focus:ring-1 focus:ring-blue-500 focus:border-transparent"
          />
          <div class="absolute inset-y-0 left-0 pl-1.5 flex items-center pointer-events-none">
            <MagnifyingGlassIcon class="h-3 w-3 text-gray-400" />
          </div>
        </div>
      </div>
      
      <!-- 市场模板列表 -->
      <div class="flex-1 overflow-y-auto">
        <div v-if="loadingMarketTemplates" class="p-4">
          <div class="animate-pulse space-y-2">
            <div class="h-4 bg-gray-200 rounded"></div>
            <div class="h-4 bg-gray-200 rounded w-4/5"></div>
            <div class="h-4 bg-gray-200 rounded w-3/5"></div>
          </div>
        </div>
        
        <div v-else-if="marketTemplates.length === 0" class="p-8 text-center text-gray-500">
          <DocumentTextIcon class="mx-auto h-12 w-12 text-gray-400 mb-4" />
          <p class="text-sm">{{ marketSearchQuery ? '没有找到匹配的模板' : '暂无市场模板' }}</p>
          <p v-if="marketSearchQuery" class="text-xs text-gray-400 mt-1">尝试调整搜索关键词</p>
        </div>
        
        <div v-else class="divide-y divide-gray-100">
          <div
            v-for="template in marketTemplates"
            :key="template.id"
            class="p-4 hover:bg-gray-50 transition-colors relative"
            :class="{ 
              'opacity-50 pointer-events-none': importingTemplateId && importingTemplateId !== template.id 
            }"
          >
            <div class="flex items-start justify-between">
              <div class="flex-1 min-w-0">
                <div class="flex items-center justify-between mb-1">
                  <!-- 标题和推荐徽章区域 -->
                  <div class="flex items-center gap-2 flex-1 min-w-0 mr-2">
                    <h4 class="text-sm font-medium text-gray-900 truncate">{{ template.name }}</h4>
                    <span v-if="template.is_featured" class="inline-flex items-center px-1.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800 flex-shrink-0">
                      推荐
                    </span>
                  </div>
                  
                  <!-- 操作按钮组 - 固定在右侧 -->
                  <div class="flex items-center space-x-1 flex-shrink-0">
                  <!-- 预览按钮 -->
                  <button
                    @click.stop="showMarketTemplatePreview(template)"
                    :disabled="previewingTemplateId === template.id"
                    class="inline-flex items-center text-gray-600 hover:text-gray-900 bg-gray-50 hover:bg-gray-100 px-2 py-1 rounded text-xs transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                    title="预览模板"
                  >
                    <div v-if="previewingTemplateId === template.id" class="animate-spin h-4 w-4 mr-1">
                      <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                    </div>
                    <EyeIcon v-else class="h-4 w-4 mr-1" />
                    {{ previewingTemplateId === template.id ? '预览' : '预览' }}
                  </button>
                  
                  <!-- 导入按钮 -->
                  <button
                    @click.stop="importMarketTemplate(template)"
                    :disabled="importingTemplateId === template.id"
                    class="inline-flex items-center text-blue-600 hover:text-blue-900 bg-blue-50 hover:bg-blue-100 px-2 py-1 rounded text-xs transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                    title="导入到我的模板"
                  >
                    <svg v-if="importingTemplateId !== template.id" class="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    <div v-else class="animate-spin h-4 w-4 mr-1">
                      <svg class="w-4 h-4" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" fill="none"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                    </div>
                    {{ importingTemplateId === template.id ? '导入' : '导入' }}
                  </button>
                  </div>
                </div>
                <p class="text-xs text-gray-500 mt-1">{{ template.category_display || template.category || '未分类' }}</p>
                <p class="text-xs text-gray-400 mt-1 line-clamp-2">{{ template.description || '暂无描述' }}</p>
                
                <!-- 标签显示 -->
                <div v-if="template.tags_list && template.tags_list.length" class="flex flex-wrap gap-1 mt-2">
                  <span 
                    v-for="tag in template.tags_list.slice(0, 3)" 
                    :key="tag"
                    class="inline-flex items-center px-1.5 py-0.5 rounded text-xs bg-blue-50 text-blue-600"
                  >
                    {{ tag }}
                  </span>
                  <span v-if="template.tags_list.length > 3" class="text-xs text-gray-400">
                    +{{ template.tags_list.length - 3 }}
                  </span>
                </div>
                
                <div class="flex items-center mt-2 text-xs text-gray-400">
                  <span>下载 {{ template.download_count || 0 }} 次</span>
                  <span class="mx-2">•</span>
                  <div class="flex items-center">
                    <svg class="h-3 w-3 text-yellow-400 mr-1" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                    <span>{{ template.rating || 0 }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
    
    <!-- 分类管理模态框 -->
    <CategoryManagementModal
      :show="manageCategoriesModal"
      :categories="categories"
      :loading="loading"
      @close="manageCategoriesModal = false"
      @add-category="handleAddCategory"
      @update-category="handleUpdateCategory"
      @delete-category="handleDeleteCategory"
      @refresh="loadCategories"
    />
    
    <!-- 敏感词警告模态框 -->
    <SensitiveWordWarningModal
      :show="showSensitiveWordWarning"
      :sensitive-word-data="sensitiveWordData"
      @confirm="handleSensitiveWordWarningConfirm"
      @close="handleSensitiveWordWarningClose"
    />

    <!-- 敏感词错误模态框 -->
    <SensitiveWordErrorModal
      :show="showSensitiveWordError"
      :sensitive-word-data="sensitiveWordErrorData"
      @close="handleSensitiveWordErrorClose"
    />
  </div>
  
  <!-- 预览模态框 -->
  <div v-if="showPreviewModal" class="fixed inset-0 z-50 overflow-y-auto">
    <div class="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity" @click="showPreviewModal = false">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>
      <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-4xl sm:w-full sm:p-6">
        <div class="flex items-center justify-between mb-4">
          <h3 class="text-lg font-medium text-gray-900">模板预览</h3>
          <button @click="showPreviewModal = false" class="text-gray-400 hover:text-gray-600">
            <XMarkIcon class="h-6 w-6" />
          </button>
        </div>
        <div class="border rounded-lg p-6">
          <div class="mb-4">
            <div class="text-sm text-gray-500">主题:</div>
            <div class="font-medium">{{ formData.subject || '(无主题)' }}</div>
          </div>
          <div class="border-t pt-4">
            <div class="text-sm text-gray-500 mb-2">内容:</div>
            <div class="prose max-w-none" v-html="formData.body_html || '(无内容)'"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <!-- 市场模板预览模态框 -->
  <div v-if="showMarketPreviewModal" class="fixed inset-0 z-50 overflow-y-auto">
    <div class="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity" @click="showMarketPreviewModal = false">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>
      <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-4xl sm:w-full sm:p-6">
        <div class="flex items-center justify-between mb-4">
          <h3 class="text-lg font-medium text-gray-900">市场模板预览</h3>
          <button @click="showMarketPreviewModal = false" class="text-gray-400 hover:text-gray-600">
            <XMarkIcon class="h-6 w-6" />
          </button>
        </div>
        <div v-if="marketPreviewData" class="border rounded-lg p-6">
          <div class="mb-4">
            <div class="text-sm text-gray-500">模板名称:</div>
            <div class="font-medium">{{ marketPreviewData.name }}</div>
          </div>
          <div class="mb-4">
            <div class="text-sm text-gray-500">邮件主题:</div>
            <div class="font-medium">{{ marketPreviewData.subject || '无邮件主题' }}</div>
          </div>
          <div class="border-t pt-4">
            <div class="text-sm text-gray-500 mb-2">邮件内容:</div>
            <div class="prose max-w-none" v-html="marketPreviewData.body_html || marketPreviewData.description || '暂无内容'"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- AI 助手组件 -->
  <AIAssistant :on-generated="handleAIGenerated" />
</template>

<script setup>
import { ref, reactive, computed, onMounted, onUnmounted, watch, nextTick } from 'vue'
import { useToast } from 'vue-toastification'
import {
  PlusIcon, DocumentTextIcon, MagnifyingGlassIcon, DocumentDuplicateIcon,
  TrashIcon, CheckIcon, EyeIcon, EyeSlashIcon, PlusCircleIcon, XMarkIcon
} from '@heroicons/vue/24/outline'
import CategoryManagementModal from '@/components/templates/CategoryManagementModal.vue'
import SensitiveWordWarningModal from '@/components/templates/SensitiveWordWarningModal.vue'
import SensitiveWordErrorModal from '@/components/templates/SensitiveWordErrorModal.vue'
import TinyMCEEditor from '@/components/common/TinyMCEEditor.vue'
import AIAssistant from '@/components/templates/AIAssistant.vue'
import emailTemplateService from '@/services/emailTemplateService'
// 使用真实的 V2 API 服务

const toast = useToast()

// 编辑器实例引用
const editorInstance = ref(null)
const subjectInput = ref(null)  // 🔧 主题输入框引用
const lastFocusedInput = ref('editor')  // 🔧 记录最后聚焦的输入框: 'subject' 或 'editor'

// 状态管理
const loading = ref(false)
const isSaving = ref(false)
const isDirty = ref(false)
const showEditor = ref(false)
const showPreviewModal = ref(false)
const manageCategoriesModal = ref(false)
const showSensitiveWordWarning = ref(false)
const sensitiveWordData = ref({})

// 敏感词错误相关状态
const showSensitiveWordError = ref(false)
const sensitiveWordErrorData = ref({})


const searchQuery = ref('')
const selectedCategory = ref('')
const marketSearchQuery = ref('')
const allTemplates = ref([])
const categories = ref([])
const allMarketTemplates = ref([])
const currentTemplate = ref(null)
const loadingMarketTemplates = ref(false)
const loadingTemplateId = ref(null)
const importingTemplateId = ref(null)
const previewingTemplateId = ref(null)
const showMarketPreviewModal = ref(false)
const marketPreviewData = ref(null)

// 下拉框状态和引用
const isCategoryOpen = ref(false)
const categorySelectRef = ref(null)
const isFormCategoryOpen = ref(false)
const formCategorySelectRef = ref(null)

// 表单数据
const formData = reactive({
  name: '',
  category: '',
  subject: '',
  body_html: '',
  is_active: true
})

// 计算属性
const isEditing = computed(() => !!(currentTemplate.value?.id))

// 前端搜索过滤 - 我的模板
const templates = computed(() => {
  const templatesArray = Array.isArray(allTemplates.value) ? allTemplates.value : []
  
  let filtered = templatesArray
  
  // 按分类筛选
  if (selectedCategory.value) {
    filtered = filtered.filter(template => 
      template && template.category == selectedCategory.value
    )
  }
  
  // 按搜索关键词筛选
  if (searchQuery.value) {
    const query = searchQuery.value.toLowerCase()
    filtered = filtered.filter(template => 
      template && (
        (template.name && template.name.toLowerCase().includes(query)) ||
        (template.subject && template.subject.toLowerCase().includes(query)) ||
        (template.preview_text && template.preview_text.toLowerCase().includes(query))
      )
    )
  }
  
  return filtered
})

// 前端搜索过滤 - 市场模板
const marketTemplates = computed(() => {
  const templatesArray = Array.isArray(allMarketTemplates.value) ? allMarketTemplates.value : []
  
  if (!marketSearchQuery.value) {
    return templatesArray
  }
  
  const query = marketSearchQuery.value.toLowerCase()
  return templatesArray.filter(template => 
    template && (
      (template.name && template.name.toLowerCase().includes(query)) ||
      (template.description && template.description.toLowerCase().includes(query)) ||
      (template.tags_list && template.tags_list.some(tag => tag.toLowerCase().includes(query)))
    )
  )
})

// 可用变量
const availableVariables = ref([
  {
    key: 'customer_name',
    placeholder: '{{customer_name}}',
    description: '客户姓名'
  },
  {
    key: 'customer_email',
    placeholder: '{{customer_email}}',
    description: '客户邮箱'
  },
  {
    key: 'customer_phone',
    placeholder: '{{customer_phone}}',
    description: '客户电话'
  },
  {
    key: 'customer_source',
    placeholder: '{{customer_source}}',
    description: '客户来源'
  },
  {
    key: 'order_number',
    placeholder: '{{order_number}}',
    description: '订单号'
  },
  {
    key: 'customer_country',
    placeholder: '{{customer_country}}',
    description: '客户国家'
  },
  {
    key: 'customer_state',
    placeholder: '{{customer_state}}',
    description: '客户州/省'
  },
  {
    key: 'customer_city',
    placeholder: '{{customer_city}}',
    description: '客户城市'
  },
  {
    key: 'customer_address',
    placeholder: '{{customer_address}}',
    description: '客户详细地址'
  },
  {
    key: 'customer_postal_code',
    placeholder: '{{customer_postal_code}}',
    description: '客户邮政编码'
  },
  {
    key: 'current_date',
    placeholder: '{{current_date}}',
    description: '当前日期时间'
  }
])


// 方法
// 计算编辑器高度
const calculateEditorHeight = () => {
  // 返回像素值
  if (typeof window !== 'undefined') {
    const windowHeight = window.innerHeight
    return Math.max(400, windowHeight - 425)
  }
  return 500
}

const loadTemplates = async () => {
  loading.value = true
  try {
    // 后端默认每页仅返回 20 条，这里按最大页大小循环翻页拉取全部模板，
    // 以保证列表、搜索、分类过滤都能覆盖所有模板（前端本地过滤）
    const pageSize = 100
    let page = 1
    const all = []
    while (true) {
      const response = await emailTemplateService.getTemplates({ page, page_size: pageSize })
      if (!response.success) break
      const results = response.results || []
      all.push(...results)
      // 非分页返回（results 即全部）或已到最后一页时停止
      if (!response.next || results.length < pageSize) break
      page += 1
    }
    allTemplates.value = all
  } catch (error) {
    toast.error('加载模板失败')
    console.error('加载模板失败:', error)
  } finally {
    loading.value = false
  }
}

const loadCategories = async () => {
  try {
    const response = await emailTemplateService.getCategories()
    if (response.success) {
      categories.value = response.results
    } else {
      toast.error(response.message || '加载分类失败')
    }
  } catch (error) {
    toast.error('加载分类失败')
    console.error('加载分类失败:', error)
  }
}

// 搜索和分类筛选已改为使用计算属性自动过滤，不需要再调用API

// 下拉框方法
const toggleCategoryDropdown = () => {
  isCategoryOpen.value = !isCategoryOpen.value
  if (isFormCategoryOpen.value) isFormCategoryOpen.value = false
}

const selectCategory = (value) => {
  selectedCategory.value = value
  isCategoryOpen.value = false
}

const toggleFormCategoryDropdown = () => {
  isFormCategoryOpen.value = !isFormCategoryOpen.value
  if (isCategoryOpen.value) isCategoryOpen.value = false
}

const selectFormCategory = (value) => {
  formData.category = value
  isFormCategoryOpen.value = false
  markDirty()
}

// 关闭所有下拉框
const closeAllDropdowns = () => {
  isCategoryOpen.value = false
  isFormCategoryOpen.value = false
}

// 点击外部关闭下拉框
const handleClickOutside = (event) => {
  if (categorySelectRef.value && !categorySelectRef.value.contains(event.target)) {
    isCategoryOpen.value = false
  }
  if (formCategorySelectRef.value && !formCategorySelectRef.value.contains(event.target)) {
    isFormCategoryOpen.value = false
  }
}

const createNewTemplate = () => {
  currentTemplate.value = null
  resetForm()
  showEditor.value = true
  isDirty.value = false
}

// 处理 AI 生成的内容
const handleAIGenerated = (htmlContent) => {
  // 直接替换编辑器内容
  formData.body_html = htmlContent
  isDirty.value = true
  
  // 如果当前没有打开编辑器，则打开编辑器
  if (!showEditor.value && !currentTemplate.value) {
    createNewTemplate()
  }
  
  // 显示成功提示
  toast.success('AI 邮件内容已生成，您可以继续编辑')
}

const selectTemplate = async (template) => {
  // 显示加载状态
  loadingTemplateId.value = template.id
  
  try {
    // 获取完整的模板详情（包括HTML内容）
    const response = await emailTemplateService.getTemplate(template.id)
    
    if (response.success) {
      currentTemplate.value = response.data
      fillForm(response.data)
      showEditor.value = true
      isDirty.value = false
    } else {
      toast.error(response.message || '获取模板详情失败')
      console.error('获取模板详情失败:', response)
    }
  } catch (error) {
    toast.error('获取模板详情失败，请稍后重试')
    console.error('获取模板详情失败:', error)
  } finally {
    loadingTemplateId.value = null
  }
}

const resetForm = () => {
  formData.name = ''
  formData.category = ''
  formData.subject = ''
  formData.body_html = ''
  formData.is_active = true
  
  // 确保删除任何意外的字段
  const allowedKeys = ['name', 'category', 'subject', 'body_html', 'is_active']
  Object.keys(formData).forEach(key => {
    if (!allowedKeys.includes(key)) {
      delete formData[key]
    }
  })
}

const fillForm = (template) => {
  formData.name = template.name
  formData.category = template.category
  formData.subject = template.subject
  formData.body_html = template.body_html
  formData.is_active = template.is_active
}

const markDirty = () => {
  isDirty.value = true
}

// 格式化字段级错误信息
const formatFieldErrors = (fieldErrors) => {
  if (!fieldErrors || typeof fieldErrors !== 'object') {
    return ''
  }
  
  const fieldMessages = []
  const fieldNameMap = {
    'name': '模板名称',
    'subject': '邮件主题',
    'body_html': '邮件内容',
    'category': '分类'
  }
  
  Object.keys(fieldErrors).forEach(field => {
    const errors = fieldErrors[field]
    const fieldDisplayName = fieldNameMap[field] || field
    
    if (Array.isArray(errors)) {
      errors.forEach(error => {
        // 处理Django REST framework的ErrorDetail对象
        const message = error.string || error.message || error
        fieldMessages.push(`${fieldDisplayName}: ${message}`)
      })
    } else if (typeof errors === 'string') {
      fieldMessages.push(`${fieldDisplayName}: ${errors}`)
    }
  })
  
  return fieldMessages.join('\n')
}

const saveTemplate = async (forceSave = false) => {
  // 确保 forceSave 是布尔值（防止事件对象被传入）
  forceSave = typeof forceSave === 'boolean' ? forceSave : false
  // 基本字段验证
  if (!formData.name || !formData.subject) {
    toast.error('请填写模板名称和邮件主题')
    return
  }
  
  // 邮件内容验证
  if (!formData.body_html || formData.body_html.trim() === '') {
    toast.error('请填写邮件内容')
    return
  }
  
  // 分类验证
  if (!formData.category) {
    toast.error('请选择模板分类')
    return
  }
  
  
  isSaving.value = true
  try {
    const templateData = { ...formData }
    // 如果是强制保存，添加 force_save 参数
    if (forceSave) {
      templateData.force_save = true
    }
    
    let response
    
    if (isEditing.value) {
      response = await emailTemplateService.updateTemplate(currentTemplate.value.id, templateData)
    } else {
      response = await emailTemplateService.createTemplate(templateData)
    }
    
    if (response.success) {
      toast.success(isEditing.value ? '模板更新成功' : '模板创建成功')
      
      // 处理API返回数据
      if (isEditing.value) {
        // 更新操作：API可能只返回部分数据，保持现有ID
        if (response.data && response.data.id) {
          currentTemplate.value = response.data
        } else {
          // 如果返回数据缺少ID，合并到现有模板数据中
          currentTemplate.value = {
            ...currentTemplate.value,
            ...response.data,
            id: currentTemplate.value.id // 保持原有ID
          }
        }
      } else {
        // 创建操作：确保获取完整数据
        if (response.data && response.data.id) {
          try {
            const detailResponse = await emailTemplateService.getTemplate(response.data.id)
            if (detailResponse.success) {
              currentTemplate.value = detailResponse.data
            } else {
              currentTemplate.value = response.data
            }
          } catch (error) {
            currentTemplate.value = response.data
          }
        } else {
          currentTemplate.value = response.data
        }
      }
      
      isDirty.value = false
      await loadTemplates()
      
      // 关闭敏感词警告模态框
      showSensitiveWordWarning.value = false
    } else {
      // 显示详细的字段级错误信息
      const fieldErrorMessage = formatFieldErrors(response.fieldErrors)
      if (fieldErrorMessage) {
        toast.error(`保存失败:\n${fieldErrorMessage}`)
      } else {
        toast.error(response.message || '保存失败')
      }
    }
  } catch (error) {
    // 检查是否是敏感词相关错误（支持新的200状态码和原来的400状态码）
    const isSensitiveWordError = (
      (error.response?.status === 200 || error.response?.status === 400) && 
      error.response?.data?.sensitive_word_data
    )
    
    if (isSensitiveWordError) {
      if (error.response.data.warning) {
        // 这是敏感词警告，显示警告模态框（允许继续保存）
        // 过滤出非禁止级别的敏感词
        const warningWords = error.response.data.sensitive_word_data.detected_words.filter(
          word => word.severity_level !== 'forbidden'
        )
        const warningData = {
          ...error.response.data.sensitive_word_data,
          detected_words: warningWords
        }
        sensitiveWordData.value = warningData
        showSensitiveWordWarning.value = true
      } else {
        // 这是禁止级别的敏感词，显示错误模态框（不能继续保存）
        // 只显示禁止级别的敏感词
        const forbiddenWords = error.response.data.sensitive_word_data.detected_words.filter(
          word => word.severity_level === 'forbidden'
        )
        const forbiddenData = {
          ...error.response.data.sensitive_word_data,
          detected_words: forbiddenWords
        }
        sensitiveWordErrorData.value = forbiddenData
        showSensitiveWordError.value = true
      }
    } else {
      // 其他错误
      toast.error('保存失败，请稍后重试')
    }
  } finally {
    isSaving.value = false
  }
}

const duplicateTemplate = async (template) => {
  try {
    const response = await emailTemplateService.duplicateTemplate(template.id)
    if (response.success) {
      toast.success('模板复制成功')
      await loadTemplates()
      selectTemplate(response.data)
    } else {
      toast.error(response.message || '复制失败')
    }
  } catch (error) {
    toast.error('复制失败，请稍后重试')
    console.error('复制模板失败:', error)
  }
}

const deleteTemplate = async (template) => {
  if (!confirm(`确定要删除模板"${template.name}"吗？`)) {
    return
  }
  
  try {
    const response = await emailTemplateService.deleteTemplate(template.id)
    if (response.success) {
      toast.success('模板删除成功')
      if (currentTemplate.value?.id === template.id) {
        currentTemplate.value = null
        showEditor.value = false
        resetForm()
      }
      await loadTemplates()
    } else {
      toast.error(response.message || '删除失败')
    }
  } catch (error) {
    toast.error('删除失败，请稍后重试')
    console.error('删除模板失败:', error)
  }
}

const insertVariable = (variable) => {
  // 🔧 根据最后聚焦的输入框决定插入位置
  if (lastFocusedInput.value === 'subject' && subjectInput.value) {
    // 🔧 插入到主题输入框的光标位置
    const input = subjectInput.value
    const startPos = input.selectionStart || 0
    const endPos = input.selectionEnd || 0
    const textBefore = formData.subject.substring(0, startPos)
    const textAfter = formData.subject.substring(endPos)
    
    // 插入变量
    formData.subject = textBefore + variable.placeholder + textAfter
    
    // 设置光标位置到插入变量之后
    nextTick(() => {
      input.focus()
      const newPos = startPos + variable.placeholder.length
      input.setSelectionRange(newPos, newPos)
    })
    
    markDirty()
  } else {
    // 🔧 插入到富文本编辑器
    if (editorInstance.value) {
      editorInstance.value.insertVariable(variable.placeholder)
      // 插入后记录为编辑器焦点
      lastFocusedInput.value = 'editor'
    } else {
      // 降级处理：直接添加到末尾
      formData.body_html += variable.placeholder
      markDirty()
    }
  }
}

const formatDate = (dateString) => {
  const date = new Date(dateString)
  const now = new Date()
  const diffTime = Math.abs(now - date)
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
  
  if (diffDays === 1) {
    return '昨天'
  } else if (diffDays < 7) {
    return `${diffDays}天前`
  } else if (diffDays < 30) {
    const weeks = Math.floor(diffDays / 7)
    return `${weeks}周前`
  } else {
    return date.toLocaleDateString('zh-CN')
  }
}

// 市场模板相关方法
const loadMarketTemplates = async () => {
  loadingMarketTemplates.value = true
  try {
    const templatesResponse = await emailTemplateService.getMarketTemplates()
    
    if (templatesResponse.success) {
      allMarketTemplates.value = templatesResponse.results
    } else {
      toast.error(templatesResponse.message || '加载市场模板失败')
    }
  } catch (error) {
    toast.error('加载市场模板失败')
    console.error('加载市场模板失败:', error)
  } finally {
    loadingMarketTemplates.value = false
  }
}

// 市场模板搜索已改为使用计算属性自动过滤，不需要再调用API

// 显示市场模板预览弹窗
const showMarketTemplatePreview = async (template) => {
  // 设置loading状态
  previewingTemplateId.value = template.id
  
  try {
    // 获取完整的市场模板详情
    const response = await emailTemplateService.getMarketTemplate(template.id)
    
    if (response.success) {
      marketPreviewData.value = response.data
    } else {
      // 如果获取详情失败，使用列表数据
      marketPreviewData.value = template
      toast.error(response.message || '获取模板详情失败，显示基本信息')
    }
  } catch (error) {
    // 出错时使用列表数据
    marketPreviewData.value = template
    console.error('预览市场模板失败:', error)
    toast.error('获取模板详情失败，显示基本信息')
  } finally {
    // 清除loading状态
    previewingTemplateId.value = null
  }
  
  // 显示预览弹窗
  showMarketPreviewModal.value = true
}

const importMarketTemplate = async (template) => {
  // 设置导入中状态
  importingTemplateId.value = template.id
  
  try {
    const response = await emailTemplateService.importMarketTemplate(template.id)
    if (response.success) {
      toast.success(response.message || `模板"${template.name}"导入成功`)
      // 刷新我的模板列表
      await loadTemplates()
      // 不自动选择导入的模板，保持当前编辑状态
    } else {
      toast.error(response.message || '导入模板失败')
    }
  } catch (error) {
    toast.error('导入模板失败')
    console.error('导入模板失败:', error)
  } finally {
    // 清除导入中状态
    importingTemplateId.value = null
  }
}

// 分类管理相关方法
const handleAddCategory = async (categoryData) => {
  try {
    const response = await emailTemplateService.createCategory(categoryData)
    if (response.success) {
      toast.success(`分类"${categoryData.name}"添加成功`)
      await loadCategories() // 重新加载分类列表
    } else {
      // 显示详细的字段级错误信息
      const fieldErrorMessage = formatFieldErrors(response.fieldErrors)
      if (fieldErrorMessage) {
        toast.error(`添加分类失败:\n${fieldErrorMessage}`)
        console.log('分类验证错误:', response.fieldErrors)
      } else {
        toast.error(response.message || '添加分类失败')
      }
    }
  } catch (error) {
    console.error('添加分类失败:', error)
    toast.error('添加分类失败，请稍后重试')
  }
}

const handleUpdateCategory = async (categoryData) => {
  try {
    const response = await emailTemplateService.updateCategory(categoryData.id, { name: categoryData.name })
    if (response.success) {
      toast.success(`分类"${categoryData.name}"更新成功`)
      await loadCategories() // 重新加载分类列表
    } else {
      // 显示详细的字段级错误信息
      const fieldErrorMessage = formatFieldErrors(response.fieldErrors)
      if (fieldErrorMessage) {
        toast.error(`更新分类失败:\n${fieldErrorMessage}`)
        console.log('分类验证错误:', response.fieldErrors)
      } else {
        toast.error(response.message || '更新分类失败')
      }
    }
  } catch (error) {
    console.error('更新分类失败:', error)
    toast.error('更新分类失败，请稍后重试')
  }
}

const handleDeleteCategory = async (categoryId) => {
  try {
    const response = await emailTemplateService.deleteCategory(categoryId)
    if (response.success) {
      // 如果当前选中的分类被删除，则重置选择
      if (selectedCategory.value == categoryId) {
        selectedCategory.value = ''
      }
      
      // 刷新分类和模板列表
      await Promise.all([loadCategories(), loadTemplates()])
      
      toast.success('分类删除成功')
    } else {
      toast.error(response.message || '删除分类失败')
    }
  } catch (error) {
    console.error('删除分类失败:', error)
    toast.error('删除分类失败，请稍后重试')
  }
}

// 敏感词警告模态框处理方法
const handleSensitiveWordWarningConfirm = async () => {
  // 用户确认继续保存，强制保存
  await saveTemplate(true)
}

const handleSensitiveWordWarningClose = () => {
  // 用户取消保存
  showSensitiveWordWarning.value = false
  sensitiveWordData.value = {}
}

// 处理敏感词错误模态框
const handleSensitiveWordErrorClose = () => {
  showSensitiveWordError.value = false
  sensitiveWordErrorData.value = {}
}

// 监听器
watch(() => [formData.name, formData.subject, formData.body_html], () => {
  if (currentTemplate.value || showEditor.value) {
    // 延迟标记dirty，避免初始化时触发
    nextTick(() => {
      if (currentTemplate.value || showEditor.value) {
        markDirty()
      }
    })
  }
}, { deep: true })

// 键盘快捷键
const handleKeydown = (event) => {
  if (event.ctrlKey || event.metaKey) {
    if (event.key === 's') {
      event.preventDefault()
      if (isDirty.value && (currentTemplate.value || showEditor.value)) {
        saveTemplate(false)
      }
    }
  }
}

// 生命周期
onMounted(async () => {
  await Promise.all([loadTemplates(), loadCategories(), loadMarketTemplates()])
  document.addEventListener('keydown', handleKeydown)
  document.addEventListener('click', handleClickOutside)
})

onUnmounted(() => {
  document.removeEventListener('keydown', handleKeydown)
  document.removeEventListener('click', handleClickOutside)
})
</script>

<style scoped>
/* 自定义滚动条 - 仅对需要滚动的区域 */
.overflow-y-auto::-webkit-scrollbar {
  width: 6px;
}

.overflow-y-auto::-webkit-scrollbar-track {
  background: #f1f5f9;
}

.overflow-y-auto::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.overflow-y-auto::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* 文本截断样式 */
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* 代码块样式优化 */
code {
  font-family: 'SFMono-Regular', 'Monaco', 'Inconsolata', 'Roboto Mono', monospace;
}

/* 表单输入动画 */
.transition-colors {
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, color 0.15s ease-in-out;
}

/* 预览区域样式 */
.prose {
  max-width: none;
}

.prose h1, .prose h2, .prose h3, .prose h4, .prose h5, .prose h6 {
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}

.prose p {
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}

/* 实时预览区域优化 */
.h-80 {
  height: 20rem; /* 320px - 增加预览区域高度 */
}

/* 确保预览内容正确显示 */
.break-words {
  word-wrap: break-word;
  word-break: break-word;
}

/* 变量面板优化 */
.min-h-0 {
  min-height: 0;
}

/* 骨架屏动画 */
@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: .5;
  }
}

.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

/* 旋转动画 */
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.animate-spin {
  animation: spin 1s linear infinite;
}

/* 自定义宽度 */
.w-preview {
  width: 26.25rem; /* 420px - 预览&变量面板宽度 */
}

/* 自适应高度计算 */
.template-editor-container {
  height: calc(100vh - 116px - 2rem); /* 减去导航栏(48px) + tab栏(40px) + 其他边距(47px) + IframeLayout padding(p-4=1rem*2) */
}

/* 响应式调整 */
@media (min-width: 768px) {
  .template-editor-container {
    height: calc(100vh - 102px - 3rem); /* 中等及以上屏幕使用 md:p-6 (1.5rem * 2) */
  }
}

/* 4栏布局优化 */
@media (max-width: 1600px) {
  .w-80 {
    width: 18rem; /* 中等屏幕缩小侧边栏 */
  }
  .w-preview {
    width: 22rem; /* 中等屏幕缩小预览面板 */
  }
}

@media (max-width: 1400px) {
  /* 隐藏市场模板栏 */
  .template-editor-container > .w-80:last-child {
    display: none;
  }
  .w-80 {
    width: 20rem; /* 3栏布局时扩大侧边栏 */
  }
  .w-preview {
    width: 24rem; /* 3栏布局时扩大预览面板 */
  }
}

@media (max-width: 1024px) {
  .w-80 {
    width: 16rem; /* 平板端缩小侧边栏 */
  }
  .w-preview {
    width: 20rem; /* 平板端缩小预览面板 */
  }
}

@media (max-width: 768px) {
  .template-editor-container {
    flex-direction: column;
    height: calc(100vh - 60px - 2rem); /* 移动端导航栏高度 + IframeLayout padding(p-4) */
  }
  
  .w-80, .w-preview {
    width: 100%;
    height: auto;
    flex: none;
  }
  
  .flex-1.flex.flex-col {
    height: 60vh;
    flex: 1;
  }
}

/* 模板页面优化样式 */
.template-editor-content {
  max-height: calc(100vh - 200px);
  overflow: hidden;
}
</style>
